import sha256 from "fast-sha256";

function toHexString(byteArray : Uint8Array) {
	var s = '';
	byteArray.forEach(function(byte) {
		s += ('0' + (byte & 0xFF).toString(16)).slice(-2);
	});
	return s;
}

export function getFormHashString(sessionString:string) : string{
	var textEncoder = new TextEncoder();
	var bytes = textEncoder.encode(sessionString.toLowerCase());
	var hash = sha256(bytes);
	var hashString = toHexString(hash);
	return hashString.substring(0, 32);
}	